import React from "react";

export function CardVisualisationMastercard() {
  return (
    <svg
      width="41"
      height="24"
      viewBox="0 0 41 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7455 2.56665H25.9334V21.4333H15.7455V2.56665Z"
        fill="#FF5F00"
      />
      <path
        d="M16.3924 12C16.3924 8.16667 18.1389 4.76667 20.8233 2.56667C18.8504 0.966667 16.36 0 13.6433 0C7.20713 0 2 5.36667 2 12C2 18.6333 7.20713 24 13.6433 24C16.36 24 18.8504 23.0333 20.8233 21.4333C18.1389 19.2667 16.3924 15.8333 16.3924 12Z"
        fill="#EB001B"
      />
      <path
        d="M39.6782 12C39.6782 18.6333 34.471 24 28.0349 24C25.3181 24 22.8277 23.0333 20.8549 21.4333C23.5716 19.2333 25.2858 15.8333 25.2858 12C25.2858 8.16667 23.5393 4.76667 20.8549 2.56667C22.8277 0.966667 25.3181 0 28.0349 0C34.471 0 39.6782 5.4 39.6782 12Z"
        fill="#F79E1B"
      />
    </svg>
  );
}
